import Footer from "../../../components/footer";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { DestinationAccountControllerType } from "../useDestinationAccount";
import { AccountTile, Button } from "@manifesthhqinc/ui-library";
import { TileContainer } from "./styles";
import { HeadlineMedium } from "../../../components/font";
import HeadingContainer from "../../../layout/heading-container";
import { AccountType } from "../../../class/destinationAccount";
import transformAccountTypeDisplayName from "../../../utils/transformAccountTypeDisplayName";

const MainScreen = (props: DestinationAccountControllerType) => {
  const { onClickContinue, currentDestinationDetails } = props;
  const isEmployerSponsored = currentDestinationDetails.destinationAccountType === AccountType.employerSponsored;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="destination-overview">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <HeadlineMedium $textAlign="center">Your destination account</HeadlineMedium>
          </HeadingContainer>

          <TileContainer $flexDirection="column" $width="100%" $marginTop={"24px"}>
            <AccountTile
              type="destination-account"
              title={
                isEmployerSponsored ? currentDestinationDetails.planSponsor : currentDestinationDetails.providerName
              }
              subtitle={
                currentDestinationDetails.destinationAccountType === AccountType.ANNUITY ? (
                  <>
                    {transformAccountTypeDisplayName(currentDestinationDetails.destinationAccountType)}
                    <br />
                    {currentDestinationDetails.planNumber.slice(-4)}
                  </>
                ) : isEmployerSponsored ? (
                  currentDestinationDetails.providerName ||
                  transformAccountTypeDisplayName(currentDestinationDetails.destinationAccountType)
                ) : (
                  <>
                    Individual Retirement Account
                    <br />
                    {currentDestinationDetails.traditionalIraAccountNumber?.slice(-4)}
                  </>
                )
              }
            />
          </TileContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="continue" onClick={onClickContinue} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default MainScreen;
